<template>
  <div class="card mt-5 dash">
    <div class="card-header d-flex justify-content-between">
      <div class="card-title" v-if="type == 'business-note'">
        {{ $t("message.menu.business_note_history") }}
      </div>
      <div class="card-title" v-else>
        {{ $t("message.menu.partner_search_history") }}
      </div>
      <router-link :to="{ name: wholeHistoryLink }" class="text-button">
        {{ $t("message.menu.all_records") }}
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.52827 3.52876C5.78862 3.26841 6.21073 3.26841 6.47108 3.52876L10.4711 7.52876C10.7314 7.78911 10.7314 8.21122 10.4711 8.47157L6.47108 12.4716C6.21073 12.7319 5.78862 12.7319 5.52827 12.4716C5.26792 12.2112 5.26792 11.7891 5.52827 11.5288L9.05687 8.00016L5.52827 4.47157C5.26792 4.21122 5.26792 3.78911 5.52827 3.52876Z"
            fill="#47B2E4"
          />
        </svg>
      </router-link>
    </div>
    <div class="card-body">
      <b-table :fields="history_fields" :items="filtered_history">
        <template v-slot:cell(action)="data">
          <button class="btn p-0 btn-link" @click="openSearch(data.item)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.3257 14.8987L21.7057 20.2787C21.8948 20.468 22.001 20.7246 22.0009 20.9921C22.0008 21.2596 21.8945 21.5161 21.7052 21.7052C21.516 21.8943 21.2594 22.0005 20.9919 22.0004C20.7244 22.0003 20.4678 21.894 20.2787 21.7047L14.8987 16.3247C13.2905 17.5704 11.268 18.1566 9.24287 17.9641C7.21772 17.7716 5.34198 16.8148 3.99723 15.2884C2.65248 13.7619 1.93973 11.7806 2.004 9.74729C2.06826 7.71402 2.9047 5.7816 4.34315 4.34315C5.7816 2.9047 7.71402 2.06826 9.74729 2.004C11.7806 1.93973 13.7619 2.65248 15.2884 3.99723C16.8148 5.34198 17.7716 7.21772 17.9641 9.24287C18.1566 11.268 17.5704 13.2905 16.3247 14.8987H16.3257ZM10.0007 15.9997C11.592 15.9997 13.1182 15.3676 14.2434 14.2424C15.3686 13.1172 16.0007 11.591 16.0007 9.99974C16.0007 8.40845 15.3686 6.88232 14.2434 5.7571C13.1182 4.63189 11.592 3.99974 10.0007 3.99974C8.40944 3.99974 6.88332 4.63189 5.7581 5.7571C4.63289 6.88232 4.00074 8.40845 4.00074 9.99974C4.00074 11.591 4.63289 13.1172 5.7581 14.2424C6.88332 15.3676 8.40944 15.9997 10.0007 15.9997Z"
                fill="#47B2E4"
              />
            </svg>
          </button>
        </template>
        <template v-slot:cell(service_code)="data">
          <button class="btn p-0 btn-link">
            {{ displayServicesName(data.value) }}
          </button>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      total_count: 0,

      analyse_id: false,

      sia_loading: false,
      sia_time: "",
      sia_time_start: 0,
      sia_timer: null,
      sia_result_text: "",
      sia: {},

      perpage: 10,
      page: 1,

      annual_info_data: {},
      risk_info_data: {},
      search_company_info_complete: false,
      anual_search_complete: false,
      risk_search_complete: false,
      court_search_complete: false,
      news_search_complete: false,
      enterprise_fuzzy_complete: false,
      no_result: false,
      court_info_data: {
        response_info: {},
      },
      news_info_data: {
        response_info: {},
      },
      business_fuzzy_info: {
        response_info: {},
        Paging: {},
      },
      company_info_data: {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      },
      total_loaded: 0,
      loading: -1,
      current_history_item: { service_code: "", log_data: {} },
      history: [],
      service_codes: [
        {
          value: "430",
          display_text: this.$t("message.find_partner.common_info_cn"),
        },
        {
          value: "930",
          display_text: this.$t("message.find_partner.court_notice_info"),
        },
        {
          value: "701",
          display_text: this.$t("message.find_partner.corporate_news_search"),
        },
        {
          value: "213",
          display_text: this.$t("message.contragent_search.annual_report"),
        },
        {
          value: "736",
          display_text: this.$t(
            "message.contragent_search.enterprise_risk_scan",
          ),
        },
        {
          value: "886",
          display_text: this.$t("message.find_partner.fuzzy_search_cn"),
        },
      ],
      history_fields: [
        {
          key: "date",
          label: this.$t("message.contragent_search.date"),
          sortable: true,
        },
        {
          key: "search_text",
          label: this.$t("message.contragent_search.search_text"),
          sortable: true,
        },
        // {
        // 	key: 'service_code',
        // 	label: this.$t('message.contragent_search.service_code'),
        // 	sortable: true
        // },
        {
          key: "action",
          label: "",
          sortable: false,
        },
      ],
      timer_seconds: "00",
      timer_minutes: "00",
      interval: "",
      service_code_list: [],
      pdf_document: {},
      pdf_parameters: {},
    };
  },
  props: {
    type: String,
  },
  mounted() {
    console.log("user");
    console.log(this.$store.state.user);
    setTimeout(() => {
      this.load();
    }, 1000);
  },
  watch: {
    type() {
      this.load();
    },
  },
  computed: {
    wholeHistoryLink() {
      switch (this.type) {
        case "business-note":
          return "business-note-hist-tab";
        case "find-partner-410":
          return "find-partner-410-hist-tab";
        default:
          return "find-partner-info-hist-tab";
      }
    },
    filtered_history() {
      return this.history.splice(0, 3);
    },
  },
  methods: {
    openSearch(data) {
      if (this.type == "business-note") {
        this.$router.push({
          name: "bn-single",
          params: {
            data,
          },
        });
      } else {
        if (this.type == "find-partner-410") {
          this.$router.push({
            name: "cs-410-single",
            params: {
              data,
            },
          });
        } else {
          this.$router.push({
            name: "cs-single",
            params: {
              data,
            },
          });
        }
      }
    },
    load() {
      let isLookup = 3;
      if (this.type == "business-note") isLookup = 0;
      if (this.type == "find-partner-410") isLookup = 1;
      axios
        .get(
          window.base +
            "/contract/getSearchLog?page=" +
            this.page +
            "&pageSize=" +
            this.perpage +
            "&isLookup=" +
            isLookup,
        )
        .then((response) => {
          this.history = response.data;
          this.total_count = parseInt(response.data[0].total_count);
        });
    },
  },
};
</script>
